import Phaser from 'phaser';
import { TILE_WIDTH, TILE_HEIGHT } from '@/config';

/** Generate an isometric diamond floor tile texture */
export function generateFloorTile(scene: Phaser.Scene): void {
  const key = 'floor-tile';
  if (scene.textures.exists(key)) return;

  const w = TILE_WIDTH;
  const h = TILE_HEIGHT;
  const canvas = scene.textures.createCanvas(key, w, h)!;
  const ctx = canvas.context;

  // Draw isometric diamond
  ctx.beginPath();
  ctx.moveTo(w / 2, 0);       // top
  ctx.lineTo(w, h / 2);       // right
  ctx.lineTo(w / 2, h);       // bottom
  ctx.lineTo(0, h / 2);       // left
  ctx.closePath();

  // Dark concrete fill
  ctx.fillStyle = '#1a1a2e';
  ctx.fill();

  // Subtle grid line
  ctx.strokeStyle = '#2a2a4e';
  ctx.lineWidth = 1;
  ctx.stroke();

  canvas.refresh();
}

/** Generate a highlighted floor tile for hover/placement preview */
export function generateHighlightTile(scene: Phaser.Scene, key: string, color: string): void {
  if (scene.textures.exists(key)) return;

  const w = TILE_WIDTH;
  const h = TILE_HEIGHT;
  const canvas = scene.textures.createCanvas(key, w, h)!;
  const ctx = canvas.context;

  ctx.beginPath();
  ctx.moveTo(w / 2, 0);
  ctx.lineTo(w, h / 2);
  ctx.lineTo(w / 2, h);
  ctx.lineTo(0, h / 2);
  ctx.closePath();

  ctx.fillStyle = color;
  ctx.globalAlpha = 0.4;
  ctx.fill();
  ctx.globalAlpha = 1.0;
  ctx.strokeStyle = color;
  ctx.lineWidth = 2;
  ctx.stroke();

  canvas.refresh();
}
